import { CellContext } from '@tanstack/react-table';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';

import { WebEDIRowData } from 'support/types/webediTable';
import { DiffStatus } from 'components/DataTable/types';

type Table = CellContext<WebEDIRowData, unknown>['table'];

type CellDiffResult = {
  status: DiffStatus;
  originalValue?: string | number | boolean | null;
};

export const getCellDiff = (fieldId: string, table: Table): CellDiffResult | undefined => {
  const baseData = table.options.meta?.baseData;
  const revisedData = table.options.meta?.revisedData;
  const dataPrefix = table.options.meta?.dataPrefix;

  if (!baseData || !revisedData || !dataPrefix) {
    return undefined;
  }

  const relativePath = fieldId.startsWith(`${dataPrefix}.`) ? fieldId.slice(dataPrefix.length + 1) : fieldId;

  const baseValue = get(baseData, relativePath);
  const revisedValue = get(revisedData, relativePath);

  if (baseValue === undefined && revisedValue !== undefined) {
    return { status: 'added' };
  }

  if (!isEqual(baseValue, revisedValue)) {
    return { status: 'modified', originalValue: baseValue };
  }

  return undefined;
};
